class InfoDataStatistique{
    constructor(libelle,totalValue,icone){
        this.libelle = libelle;
        this.totalValue = totalValue;
        this.icone = icone;
    }

    handleInfoDataStatistique(){
        return {libelle:this.libelle,
            totalValue:this.totalValue,
            icone:this.icone
        }
    }
}
export default InfoDataStatistique;